import React, { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import {
  ChevronDown,
  Users,
  Package,
  DollarSign,
  Settings,
  UserCheck,
  BarChart3,
  ShoppingCart,
  Percent,
  History,
  Save,
  Edit3,
  Building,
  Archive,
  TrendingUp,
  RefreshCw,
  User,
  Plus,
  Trash2,
} from "lucide-react";
import { AnimatePresence } from "framer-motion";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { useAuthStore } from "../../store/auth";
import { useProdutosStore } from "../../store/produtos";
import { api } from "../../api/greenclub";
import BusinessIntelligence from "./BusinessIntelligence"; // Caminho já estava correto
const RepresentativeOnboarding = React.lazy(() =>
  import("./RepresentativeOnboarding")
);
const CouponManager = React.lazy(() => import("./CouponManager"));
const CouponStockManager = React.lazy(() => import("./CouponStockManager"));
const DashboardAdmin = () => {
  async function loadConfiguracoes() {
    try {
      // Esta função parece estar sendo chamada no lugar errado, movendo a lógica para o useEffect principal
      setLoading(true);
      const response = await api.getConfiguracoes();
      if (response.success) {
        setConfiguracoes(response.configuracoes);
      }
    } catch (error) {
      console.error("Erro ao carregar configurações:", error);
    } finally {
      setLoading(false);
    }
  }
  const { user, logout } = useAuthStore();
  const { produtos } = useProdutosStore();
  const [activeTab, setActiveTab] = useState("overview"); // Corrigido para 'overview'
  const [configuracoes, setConfiguracoes] = useState([]);
  const [produtoComissoes, setProdutoComissoes] = useState([]);
  const [historicoPrecos, setHistoricoPrecos] = useState([]);
  const [loading, setLoading] = useState(true); // Inicia como true
  const [dashboardData, setDashboardData] = useState(null);
  const [editingConfig, setEditingConfig] = useState(null);
  const [editingComissao, setEditingComissao] = useState(null);
  const [editingPreco, setEditingPreco] = useState(null);
  useEffect(() => {
    const carregarDadosDoDashboard = async () => {
      if (activeTab === "overview") {
        try {
          setLoading(true);
          const response = await api.getAdminDashboard();
          if (response.success) {
            setDashboardData(response);
          }
        } catch (error) {
          console.error("Erro ao carregar dados do dashboard:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    carregarDadosDoDashboard();
    if (activeTab === "inteligencia") {
      // Mantém a lógica original para a aba de inteligência
      // loadConfiguracoes();
      // loadProdutoComissoes();
      // loadHistoricoPrecos();
    }
  }, [activeTab]);
  async function loadProdutoComissoes() {
    try {
      const response = await api.getProdutoComissoes();
      if (response.success) {
        setProdutoComissoes(response.comissoes);
      }
    } catch (error) {
      console.error("Erro ao carregar comissões:", error);
    }
  }
  async function loadHistoricoPrecos() {
    try {
      const response = await api.getHistoricoPrecos();
      if (response.success) {
        setHistoricoPrecos(response.historico);
      }
    } catch (error) {
      console.error("Erro ao carregar histórico:", error);
    }
  }
  async function handleUpdateConfiguracao(chave, valor) {
    try {
      const response = await api.updateConfiguracao(chave, valor);
      if (response.success) {
        setConfiguracoes((prev) =>
          prev.map((config) =>
            config.chave === chave ? { ...config, valor } : config
          )
        );
        setEditingConfig(null);
      }
    } catch (error) {
      console.error("Erro ao atualizar configuração:", error);
    }
  }
  async function handleUpdateComissao(
    produtoId,
    medicoPercentual,
    representantePercentual
  ) {
    try {
      const response = await api.updateProdutoComissao(
        produtoId,
        medicoPercentual,
        representantePercentual
      );
      if (response.success) {
        setProdutoComissoes((prev) =>
          prev.map((comissao) =>
            comissao.produto_id === produtoId
              ? {
                  ...comissao,
                  medico_valor: medicoPercentual,
                  representante_valor: representantePercentual,
                }
              : comissao
          )
        );
        setEditingComissao(null);
      }
    } catch (error) {
      console.error("Erro ao atualizar comissão:", error);
    }
  }
  async function handleUpdatePreco(produtoId, precoNovo, motivo) {
    try {
      const response = await api.updatePreco(produtoId, precoNovo, motivo);
      if (response.success) {
        setEditingPreco(null);
        loadHistoricoPrecos(); // Recarregar histórico
        window.location.reload(); // Recarregar produtos
      }
    } catch (error) {
      console.error("Erro ao atualizar preço:", error);
    }
  }

  const getUserCount = (type) => {
    const userData = dashboardData?.stats?.users.find((u) => u.tipo === type);
    return userData ? userData.count : 0;
  };

  const statsCards = [
    {
      title: "Vendas Confirmadas",
      value: `R$ ${(
        dashboardData?.stats?.totalVendasConfirmadas || 0
      ).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`,
      icon: DollarSign,
      color: "emerald",
    },
    {
      title: "Vendas em Processamento",
      value: `R$ ${(
        dashboardData?.stats?.totalVendasEmProcessamento || 0
      ).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`,
      icon: RefreshCw,
      color: "blue",
    },
    {
      title: "Vendas Pendentes",
      value: `R$ ${(
        dashboardData?.stats?.totalVendasPendentes || 0
      ).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`,
      icon: History,
      color: "yellow",
    },
    {
      title: "Produtos Ativos",
      value: dashboardData?.stats?.totalProdutos || 0,
      icon: Package,
      color: "blue",
    },
    {
      title: "Clínicas Ativas",
      value: getUserCount("medico"),
      icon: Building,
      color: "purple",
    },
    {
      title: "Pedidos Hoje",
      value: dashboardData?.stats?.pedidosHoje || 0,
      icon: ShoppingCart,
      color: "orange",
    },
  ];

  // Componente reutilizável para os gráficos
  const SalesChart = ({ title, data, dataKey, color, icon: Icon }) => (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <Icon className={`w-5 h-5 mr-2 text-${color}-600`} />
        {title}
      </h3>
      {loading ? (
        <div className="text-center py-10">Carregando gráfico...</div>
      ) : (
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <AreaChart data={data}>
              <defs>
                <linearGradient
                  id={`color-${dataKey}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={
                      color === "emerald"
                        ? "#10b981"
                        : color === "blue"
                        ? "#3b82f6"
                        : "#f59e0b"
                    }
                    stopOpacity={0.8}
                  />
                  <stop
                    offset="95%"
                    stopColor={
                      color === "emerald"
                        ? "#10b981"
                        : color === "blue"
                        ? "#3b82f6"
                        : "#f59e0b"
                    }
                    stopOpacity={0}
                  />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis dataKey="dia" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
              <Tooltip
                formatter={(value, name, props) => {
                  if (props.payload.dataKey === "totalVendas") {
                    return `R$ ${value.toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}`;
                  }
                  return value;
                }}
              />
              <Area
                type="monotone"
                dataKey={dataKey}
                stroke={
                  color === "emerald"
                    ? "#10b981"
                    : color === "blue"
                    ? "#3b82f6"
                    : "#f59e0b"
                }
                fill={`url(#color-${dataKey})`}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );

  const groupedConfiguracoes = configuracoes.reduce((acc, config) => {
    if (!acc[config.categoria]) acc[config.categoria] = [];
    acc[config.categoria].push(config);
    return acc;
  }, {});
  const formatCategoria = (categoria) => {
    const map = {
      geral: "Configurações Gerais",
      pagamento: "Pagamentos",
      comissoes: "Comissões",
      cupons: "Cupons de Desconto",
      produtos: "Produtos",
    };
    return map[categoria] || categoria;
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
      <motion.header
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="bg-white shadow-sm border-b border-gray-200"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center flex-shrink-0">
              <h1 className="text-2xl font-bold text-emerald-800">GreenClub</h1>
              <span className="hidden md:inline-block ml-3 bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm font-medium">
                Admin - Controle Total do Sistema
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-gray-700">Olá, {user?.nome}</span>
              <button
                onClick={logout}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors"
              >
                Sair
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Tabs */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="relative mb-8"
        >
          <div className="overflow-x-auto pb-2 -mb-2">
            <div className="flex space-x-1 bg-white p-1 rounded-lg shadow-sm w-max">
              {[
                { id: "overview", label: "Visão Geral", icon: BarChart3 },
                { id: "pedidos", label: "Pedidos", icon: ShoppingCart },
                { id: "products", label: "Produtos & Preços", icon: Package },
                { id: "users", label: "Usuários", icon: Users },
                { id: "representantes", label: "Representantes", icon: UserCheck },
                { id: "cupons", label: "Cupons & Benefícios", icon: Percent },
                { id: "comissoes", label: "Saques & Comissões", icon: DollarSign },
                {
                  id: "coupon-stock",
                  label: "Estoque de Cupons",
                  icon: Archive,
                },
                {
                  id: "inteligencia",
                  label: "Inteligência do Negócio",
                  icon: Settings,
                },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 px-3 sm:px-4 py-2 rounded-md transition-colors text-sm whitespace-nowrap ${
                    activeTab === tab.id
                      ? "bg-emerald-100 text-emerald-700 font-semibold"
                      : "text-gray-600 hover:bg-gray-100 hover:text-gray-800"
                  }`}
                >
                  <tab.icon className="w-4 h-4" />
                  <span>{tab.label}</span>
                </button>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Overview Tab */}
        {activeTab === "overview" && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="space-y-8"
          >
            {/* Stats Grid */}
            {loading ? (
              <div className="text-center py-10">
                Carregando estatísticas...
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {statsCards.map((stat, index) => (
                  <motion.div
                    // Adicionando uma classe de cor específica para o ícone
                    // As cores do Tailwind precisam ser completas no código para serem detectadas
                    // Ex: text-emerald-600, bg-emerald-100
                    // A concatenação de string `text-${stat.color}-600` não funciona no build final.
                    // Vamos garantir que as classes existam.
                    key={stat.title}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 * index }}
                    className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
                  >
                    <div className="flex items-center">
                      <div className={`p-3 rounded-lg bg-${stat.color}-100`}>
                        <stat.icon
                          className={`w-6 h-6 text-${stat.color}-600`}
                        />
                      </div>
                      <div className="ml-4">
                        <p className="text-sm text-gray-600">{stat.title}</p>
                        <p className="text-2xl font-bold text-gray-900">
                          {stat.value}
                        </p>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}

            {/* Sales Chart */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <SalesChart
                title="Número de Pedidos (Últimos 30 dias)"
                data={dashboardData?.salesChartData}
                dataKey="numeroPedidos"
                color="blue"
                icon={ShoppingCart}
              />
              <SalesChart
                title="Frascos Vendidos (Últimos 30 dias)"
                data={dashboardData?.salesChartData}
                dataKey="frascosVendidos"
                color="purple"
                icon={Package}
              />
            </div>

            {/* Approvals Section */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Fluxo automático de cadastros
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Os cadastros de novos usuários (clínicas, representantes e
                pacientes) agora são processados automaticamente. Use as seções
                "Usuários" e "Representantes" para gerenciar os cadastros e
                realizar ajustes manuais quando necessário. A aprovação manual
                pode ser reativada nas configurações do sistema.
              </p>
            </div>
          </motion.div>
        )}

        {/* Products & Management Tab */}
        {activeTab === "products" && (
          <ProductManager />
        )}

        {/* Orders Tab */}
        {activeTab === "pedidos" && <OrderManager />}

        {/* Users Tab */}
        {activeTab === "users" && <UserManager />}

        {/* Representative Onboarding */}
        {activeTab === "representantes" && (
          <React.Suspense
            fallback={
              <div className="bg-white rounded-xl border border-gray-200 p-6 text-center text-gray-500">
                Carregando módulo de representantes...
              </div>
            }
          >
            <RepresentativeOnboarding />
          </React.Suspense>
        )}

        {/* Coupons Tab */}
        {activeTab === "cupons" && (
          <React.Suspense
            fallback={
              <div className="bg-white rounded-xl border border-gray-200 p-6 text-center text-gray-500">
                Carregando módulo de cupons...
              </div>
            }
          >
            <CouponManager />
          </React.Suspense>
        )}

        {/* Commissions Tab */}
        {activeTab === "comissoes" && <PayoutManager />}

        {/* Inteligência do Negócio Tab */}
        {activeTab === "inteligencia" && <BusinessIntelligence />}

        {/* Coupon Stock Tab */}
        {activeTab === "coupon-stock" && (
          <React.Suspense
            fallback={
              <div className="bg-white rounded-xl border border-gray-200 p-6 text-center text-gray-500">
                Carregando módulo de estoque de cupons...
              </div>
            }
          >
            <CouponStockManager />
          </React.Suspense>
        )}

        {/* Business Intelligence Tab */}
        {activeTab === "settings" && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="space-y-6"
          >
            {/* System Configurations */}
            {Object.entries(groupedConfiguracoes).map(
              ([categoria, configs]) => (
                <div
                  key={categoria}
                  className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
                >
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    {formatCategoria(categoria)}
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {configs.map((config) => (
                      <ConfigItem
                        key={config.chave}
                        config={config}
                        isEditing={editingConfig === config.chave}
                        onEdit={() => setEditingConfig(config.chave)}
                        onSave={(valor) =>
                          handleUpdateConfiguracao(config.chave, valor)
                        }
                        onCancel={() => setEditingConfig(null)}
                      />
                    ))}
                  </div>
                </div>
              )
            )}

            {/* Product Commissions */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
                <Percent className="w-5 h-5 mr-2" />
                Comissões por Produto
              </h3>

              <div className="space-y-4">
                {produtoComissoes.map((comissao) => (
                  <ComissaoItem
                    key={comissao.id}
                    comissao={comissao}
                    isEditing={editingComissao === comissao.produto_id}
                    onEdit={() => setEditingComissao(comissao.produto_id)}
                    onSave={handleUpdateComissao}
                    onCancel={() => setEditingComissao(null)}
                  />
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};
// Components for editing configurations
const ConfigItem = ({ config, isEditing, onEdit, onSave, onCancel }) => {
  const [valor, setValor] = useState(config.valor);
  if (isEditing) {
    return (
      <div className="p-4 border border-emerald-200 rounded-lg bg-emerald-50">
        <label className="block text-sm font-medium text-gray-900 mb-2">
          {config.descricao}
        </label>
        <div className="flex space-x-2">
          <input
            type={config.tipo === "number" ? "number" : "text"}
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            className="flex-1 p-2 border border-gray-300 rounded-lg"
          />
          <button
            onClick={() => onSave(valor)}
            className="p-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700"
          >
            <Save className="w-4 h-4" />
          </button>
          <button
            onClick={onCancel}
            className="p-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
          >
            ✕
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="p-4 border border-gray-200 rounded-lg hover:border-emerald-200 transition-colors">
      <div className="flex justify-between items-start">
        <div>
          <h4 className="text-sm font-medium text-gray-900">
            {config.descricao}
          </h4>
          <p className="text-xs text-gray-500 mt-1">Chave: {config.chave}</p>
          <p className="text-lg font-bold text-emerald-600 mt-2">
            {config.tipo === "boolean"
              ? config.valor === "true"
                ? "Ativado"
                : "Desativado"
              : config.tipo === "number" && config.chave.includes("percentual")
              ? `${config.valor}%`
              : config.valor}
          </p>
        </div>
        <button
          onClick={onEdit}
          className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-colors"
        >
          <Edit3 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
const ComissaoItem = ({ comissao, isEditing, onEdit, onSave, onCancel }) => {
  const [medicoPercentual, setMedicoPercentual] = useState(
    comissao.medico_valor || 0
  );
  const [representantePercentual, setRepresentantePercentual] = useState(
    comissao.representante_valor || 0
  );
  if (isEditing) {
    return (
      <div className="p-4 border border-emerald-200 rounded-lg bg-emerald-50">
        <h4 className="font-medium text-gray-900 mb-3">
          {comissao.produto_nome}
        </h4>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm text-gray-700 mb-1">
              Comissão Médico (%)
            </label>
            <input
              type="number"
              step="0.1"
              value={medicoPercentual}
              onChange={(e) => setMedicoPercentual(Number(e.target.value))}
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">
              Comissão Representante (%)
            </label>
            <input
              type="number"
              step="0.1"
              value={representantePercentual}
              onChange={(e) =>
                setRepresentantePercentual(Number(e.target.value))
              }
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
          </div>
        </div>
        <div className="flex space-x-2 mt-3">
          <button
            onClick={() =>
              onSave(
                comissao.produto_id,
                medicoPercentual,
                representantePercentual
              )
            }
            className="p-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700"
          >
            <Save className="w-4 h-4" />
          </button>
          <button
            onClick={onCancel}
            className="p-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
          >
            ✕
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="p-4 border border-gray-200 rounded-lg hover:border-emerald-200 transition-colors">
      <div className="flex justify-between items-center">
        <div>
          <h4 className="font-medium text-gray-900">{comissao.produto_nome}</h4>
          <p className="text-sm text-gray-600">
            R$ {comissao.produto_preco.toFixed(2)} •{" "}
            {comissao.produto_categoria}
          </p>
          <div className="flex space-x-4 mt-2">
            <span className="text-sm">
              Médico:{" "}
              <span className="font-medium text-emerald-600">
                {comissao.medico_tipo === "percentual"
                  ? `${comissao.medico_valor}%`
                  : `R$ ${comissao.medico_valor.toFixed(2)}`}
              </span>
            </span>
            <span className="text-sm">
              Representante:{" "}
              <span className="font-medium text-blue-600">
                {comissao.representante_tipo === "percentual"
                  ? `${comissao.representante_valor}%`
                  : `R$ ${comissao.representante_valor.toFixed(2)}`}
              </span>
            </span>
          </div>
        </div>
        <button
          onClick={onEdit}
          className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-colors"
        >
          <Edit3 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
const EditPrecoForm = ({ produto, onSave, onCancel }) => {
  const [precoNovo, setPrecoNovo] = useState(produto.preco);
  const [motivo, setMotivo] = useState("");
  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm text-gray-700 mb-1">Novo Preço</label>
        <input
          type="number"
          step="0.01"
          value={precoNovo}
          onChange={(e) => setPrecoNovo(Number(e.target.value))}
          className="w-full p-2 border border-gray-300 rounded-lg"
        />
      </div>
      <div>
        <label className="block text-sm text-gray-700 mb-1">
          Motivo (opcional)
        </label>
        <input
          type="text"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          placeholder="Ex: Promoção, ajuste de mercado..."
          className="w-full p-2 border border-gray-300 rounded-lg"
        />
      </div>
      <div className="flex space-x-2">
        <button
          onClick={() => onSave(produto.id, precoNovo, motivo)}
          className="flex-1 p-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700"
        >
          Salvar
        </button>
        <button
          onClick={onCancel}
          className="p-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

const OrderManager = () => {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [updatingStatusId, setUpdatingStatusId] = useState(null);

  // Estados para armazenar dados de apoio (usuários e cupons)
  const [users, setUsers] = useState([]);
  const [cupons, setCupons] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Busca todos os dados necessários em paralelo
        const [pedidosRes, usersRes, cuponsRes] = await Promise.all([
          api.getAdminPedidos(),
          api.getAdminUsers(),
          api.getCoupons(),
        ]);

        if (pedidosRes.success) {
          setPedidos(pedidosRes.pedidos);
        } else {
          throw new Error(pedidosRes.error || "Falha ao carregar pedidos.");
        }

        if (usersRes.success) {
          setUsers(usersRes.users);
        } else {
          console.warn("Não foi possível carregar os usuários.");
        }

        if (cuponsRes.success) {
          setCupons(cuponsRes.cupons);
        } else {
          console.warn("Não foi possível carregar os cupons.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const usersMap = useMemo(() => {
    return users.reduce((acc, user) => {
      acc[user.id] = user;
      return acc;
    }, {});
  }, [users]);

  const cuponsMap = useMemo(() => {
    return cupons.reduce((acc, cupom) => {
      acc[cupom.codigo] = cupom;
      return acc;
    }, {});
  }, [cupons]);

  const handleStatusChange = async (pedidoId, newStatus) => {
    setUpdatingStatusId(pedidoId);
    try {
      const response = await api.updatePedidoStatus(pedidoId, newStatus);
      if (response.success) {
        // Atualiza o estado local para feedback instantâneo
        setPedidos((prevPedidos) =>
          prevPedidos.map((p) =>
            p._id === pedidoId ? { ...p, status: newStatus } : p
          )
        );
      } else {
        alert(response.error || "Falha ao atualizar o status.");
      }
    } catch (error) {
      alert("Erro ao se comunicar com a API para atualizar o status.");
    } finally {
      setUpdatingStatusId(null);
    }
  };
  const getStatusClass = (status) => {
    const map = {
      pendente: "bg-yellow-100 text-yellow-800",
      processando: "bg-blue-100 text-blue-800",
      pagamento_aprovado: "bg-cyan-100 text-cyan-800",
      enviado: "bg-indigo-100 text-indigo-800",
      entregue: "bg-emerald-100 text-emerald-800",
      cancelado: "bg-red-100 text-red-800",
      pagamento_rejeitado: "bg-red-100 text-red-800",
    };
    return map[status] || "bg-gray-100 text-gray-800";
  };

  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-6 text-center text-gray-500">
        Carregando gerenciador de pedidos...
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border-red-200 text-red-700 p-4 rounded-lg">
        Erro: {error}
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
    >
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <ShoppingCart className="w-5 h-5 mr-2" />
        Gerenciamento de Pedidos
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="p-3 font-semibold">Pedido</th>
              <th className="p-3 font-semibold">Produto</th>
              <th className="p-3 font-semibold">Cupom / Afiliados</th>
              <th className="p-3 font-semibold">Valores</th>
              <th className="p-3 font-semibold">Comissões</th>
              <th className="p-3 font-semibold">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {pedidos.map((pedido) => {
              const item = pedido.itens[0];
              const cupom = pedido.cupom_codigo
                ? cuponsMap[pedido.cupom_codigo]
                : null;
              const clinica = cupom?.clinica_id
                ? usersMap[cupom.clinica_id]
                : null;
              const representante = cupom?.representante_id
                ? usersMap[cupom.representante_id]
                : null;

              let comissaoClinica = 0;
              let comissaoRepresentante = 0;

              if (cupom) {
                // Cálculo comissão clínica
                if (cupom.clinica_remuneracao_tipo === "percentual") {
                  comissaoClinica =
                    (pedido.total * (cupom.clinica_remuneracao_valor || 0)) /
                    100;
                } else if (cupom.clinica_remuneracao_tipo === "valor_fixo") {
                  comissaoClinica = cupom.clinica_remuneracao_valor || 0;
                }

                // Cálculo comissão representante
                if (cupom.representante_remuneracao_tipo === "percentual") {
                  comissaoRepresentante =
                    (pedido.total *
                      (cupom.representante_remuneracao_valor || 0)) /
                    100;
                } else if (
                  cupom.representante_remuneracao_tipo === "valor_fixo"
                ) {
                  comissaoRepresentante =
                    cupom.representante_remuneracao_valor || 0;
                }
              }

              return (
                <tr key={pedido._id} className="hover:bg-gray-50">
                  <td className="p-3">
                    <div className="font-medium text-gray-800">
                      #{pedido._id.slice(-6)}
                    </div>
                    <div className="text-gray-500">
                      {new Date(pedido.criado_em).toLocaleDateString("pt-BR")}
                    </div>
                    <div className="flex items-center gap-1 text-gray-600 mt-1">
                      <User className="w-3 h-3" />{" "}
                      {pedido.paciente?.nome || "N/A"}
                    </div>
                  </td>
                  <td className="p-3">
                    <div>{item.produto_nome}</div>
                    <div className="text-gray-500">
                      {item.quantidade} unidade(s)
                    </div>
                  </td>
                  <td className="p-3">
                    <div className="font-medium text-gray-800">
                      {pedido.cupom_codigo || "Nenhum"}
                    </div>
                    {clinica && (
                      <div className="text-xs text-gray-500">
                        Clínica: {clinica.nome}
                      </div>
                    )}
                    {representante && (
                      <div className="text-xs text-gray-500">
                        Rep: {representante.nome}
                      </div>
                    )}
                  </td>
                  <td className="p-3">
                    <div className="text-gray-500">
                      Subtotal: R$ {pedido.subtotal.toFixed(2)}
                    </div>
                    <div className="text-red-600">
                      Desconto: - R$ {pedido.desconto.toFixed(2)}
                    </div>
                    <div className="font-bold text-gray-800">
                      Total: R$ {pedido.total.toFixed(2)}
                    </div>
                  </td>
                  <td className="p-3">
                    {comissaoClinica > 0 && (
                      <div className="text-xs text-purple-700">
                        Clínica: R$ {comissaoClinica.toFixed(2)}
                      </div>
                    )}
                    {comissaoRepresentante > 0 && (
                      <div className="text-xs text-blue-700">
                        Rep: R$ {comissaoRepresentante.toFixed(2)}
                      </div>
                    )}
                    {comissaoClinica === 0 && comissaoRepresentante === 0 && (
                      <div className="text-xs text-gray-500">N/A</div>
                    )}
                  </td>
                  <td className="p-3">
                    {updatingStatusId === pedido._id ? (
                      <div className="flex justify-center items-center">
                        <RefreshCw className="w-4 h-4 animate-spin text-gray-500" />
                      </div>
                    ) : (
                      <select
                        value={pedido.status}
                        onChange={(e) =>
                          handleStatusChange(pedido._id, e.target.value)
                        }
                        className={`w-full px-2 py-1 text-xs font-medium rounded-full border-transparent focus:outline-none focus:ring-2 focus:ring-emerald-500 ${getStatusClass(
                          pedido.status
                        )}`}
                      >
                        <option value="pendente">Pendente</option>
                        <option value="processando">Processando</option>
                        <option value="pagamento_aprovado">
                          Pagamento Aprovado
                        </option>
                        <option value="enviado">Enviado</option>
                        <option value="entregue">Entregue</option>
                        <option value="cancelado">Cancelado</option>
                        <option value="pagamento_rejeitado">
                          Pagamento Rejeitado
                        </option>
                      </select>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </motion.div>
  );
};

const PayoutManager = () => {
  const [payouts, setPayouts] = useState([]);
  const [summary, setSummary] = useState({
    totalPendingValue: 0,
    pendingCount: 0,
    totalProcessingValue: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatingStatusId, setUpdatingStatusId] = useState(null);

  useEffect(() => {
    const fetchPayouts = async () => {
      try {
        setLoading(true);
        const response = await api.getAdminPayouts();
        if (response.success) {
          setPayouts(response.payouts);
          setSummary(response.summary);
        } else {
          throw new Error(response.error || "Falha ao carregar saques.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPayouts();
  }, []);

  const handleStatusChange = async (payout, newStatus) => {
    setUpdatingStatusId(payout.id);
    try {
      const response = await api.updatePayoutStatus(
        // CORREÇÃO: Normaliza o tipo para 'clinica' ou 'representante'
        payout.beneficiario_tipo,
        payout.id,
        newStatus
      );
      if (response.success) {
        setPayouts((prev) =>
          prev.map((c) =>
            c.id === payout.id &&
            c.beneficiario_tipo === payout.beneficiario_tipo
              ? { ...c, status: newStatus }
              : c
          )
        );
      } else {
        alert(response.error || "Falha ao atualizar o status.");
      }
    } catch (error) {
      alert("Erro ao se comunicar com a API.");
    } finally {
      setUpdatingStatusId(null);
    }
  };

  const getStatusClass = (status) => {
    const map = {
      pendente: "bg-amber-100 text-amber-800",
      processando: "bg-blue-100 text-blue-800",
      pago: "bg-emerald-100 text-emerald-800",
      rejeitado: "bg-red-100 text-red-800",
    };
    return map[status] || "bg-gray-100 text-gray-800";
  };

  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-6 text-center text-gray-500">
        Carregando solicitações de saque...
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border-red-200 text-red-700 p-6 rounded-lg">
        Erro: {error}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Resumo Financeiro
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-center gap-4 bg-amber-50 border border-amber-200 p-4 rounded-lg">
            <DollarSign className="w-8 h-8 text-amber-600 flex-shrink-0" />
            <div>
              <p className="text-sm text-amber-800 font-semibold">
                Comissões Pendentes de Saque
              </p>
              <p className="text-2xl font-bold text-amber-700">
                R${" "}
                {(summary.totalPendingValue || 0).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </p>
              <p className="text-xs text-amber-600">
                Valor que parceiros ainda podem solicitar.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4 bg-blue-50 border border-blue-200 p-4 rounded-lg">
            <RefreshCw className="w-8 h-8 text-blue-600 flex-shrink-0" />
            <div>
              <p className="text-sm text-blue-800 font-semibold">
                Total de Resgates em Processamento
              </p>
              <p className="text-2xl font-bold text-blue-700">
                R${" "}
                {(summary.totalProcessingValue || 0).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </p>
              <p className="text-xs text-blue-600">
                Soma dos saques marcados como "Processando".
              </p>
            </div>
          </div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
      >
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <History className="w-5 h-5 mr-2" />
          Gerenciamento de Solicitações de Saque
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-50 text-gray-600">
              <tr>
                <th className="p-3 font-semibold">Beneficiário</th>
                <th className="p-3 font-semibold">Valor Solicitado</th>
                <th className="p-3 font-semibold">Observação</th>
                <th className="p-3 font-semibold text-center">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {payouts.map((payout) => (
                <tr
                  key={`${payout.id}-${payout.beneficiario_tipo}`}
                  className="hover:bg-gray-50"
                >
                  <td className="p-3">
                    <div className="font-medium text-gray-800">
                      {payout.beneficiario_nome}
                    </div>
                    <div className="text-gray-500">
                      {payout.beneficiario_tipo}
                    </div>
                  </td>
                  <td className="p-3 font-bold text-emerald-600">
                    R${" "}
                    {payout.valor.toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td className="p-3 text-gray-600 max-w-xs truncate">
                    {payout.observacao || "-"}
                  </td>
                  <td className="p-3 text-center">
                    {updatingStatusId === payout.id ? (
                      <RefreshCw className="w-4 h-4 animate-spin text-gray-500 mx-auto" />
                    ) : (
                      <select
                        value={payout.status}
                        onChange={(e) =>
                          handleStatusChange(payout, e.target.value)
                        }
                        className={`px-3 py-1 text-xs font-semibold rounded-full border-transparent focus:outline-none focus:ring-2 focus:ring-emerald-500 ${getStatusClass(
                          payout.status
                        )}`}
                      >
                        <option value="pendente">Pendente</option>
                        <option value="processando">Processando</option>
                        <option value="pago">Pago</option>
                        <option value="rejeitado">Rejeitado</option>
                      </select>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
  );
};

const ProductManager = () => {
  const { produtos, carregarProdutos, criarProduto, atualizarProduto, deletarProduto } = useProdutosStore();
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await carregarProdutos();
      setLoading(false);
    };
    load();
  }, [carregarProdutos]);

  const openModal = (product = null) => {
    setEditingProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEditingProduct(null);
    setIsModalOpen(false);
  };

  const handleSave = async (productData) => {
    if (editingProduct) {
      await atualizarProduto(editingProduct._id, productData);
    } else {
      // Adiciona uma chave temporária para evitar o warning do React
      const tempProductData = {
        ...productData,
        _id: `temp-${Date.now()}` 
      };
      await criarProduto(tempProductData);
    }
    closeModal();
  };

  const handleDelete = async (productId) => {
    if (window.confirm("Tem certeza que deseja desativar este produto? Ele não poderá mais ser vendido.")) {
      await deletarProduto(productId);
    }
  };

  if (loading) {
    return <div className="text-center p-6">Carregando produtos...</div>;
  }

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <Package className="w-5 h-5 mr-2" />
            Gerenciamento de Produtos e Preços
          </h3>
          <button
            onClick={() => openModal()}
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Novo Produto
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {produtos.map((produto) => (
            <div key={produto.id || produto._id} className={`flex flex-col border rounded-lg transition-all ${produto.ativo ? 'bg-white hover:shadow-md' : 'bg-gray-100 opacity-70'}`}>
              {produto.imagem_url ? (
                <img src={produto.imagem_url} alt={produto.nome} className="h-40 w-full object-cover rounded-t-lg" />
              ) : (
                <div className="h-40 w-full bg-gray-100 rounded-t-lg flex items-center justify-center text-gray-400">
                  <Package className="w-10 h-10" />
                </div>
              )}
              <div className="p-4 flex flex-col flex-grow">
              <h4 className="font-bold text-gray-800">{produto.nome}</h4>
              <p className="text-sm text-gray-500">{produto.dosagem}</p>
              <p className="text-lg font-bold text-emerald-600 my-2">R$ {produto.preco.toFixed(2)}</p>
              <p className="text-xs text-gray-600 line-clamp-2 h-8 flex-grow">{produto.descricao}</p>
              <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between items-center">
                <span className={`text-xs font-medium px-2 py-1 rounded-full ${produto.ativo ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-700'}`}>
                  {produto.ativo ? 'Ativo' : 'Inativo'}
                </span>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleDelete(produto._id)}
                    disabled={produto._id.startsWith('temp-')}
                    className="text-red-600 hover:text-red-800 text-sm font-medium flex items-center gap-1 p-1 rounded-md hover:bg-red-50 disabled:text-gray-400 disabled:cursor-not-allowed disabled:hover:bg-transparent"
                    title="Desativar Produto"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => openModal(produto)}
                    className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1"
                  >
                    <Edit3 className="w-4 h-4" />
                    Editar
                  </button>
                </div>
              </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {isModalOpen && (
          <ProductFormModal
            product={editingProduct}
            onClose={closeModal}
            onSave={handleSave}
          />
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const ProductFormModal = ({ product, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    nome: product?.nome || '',
    descricao: product?.descricao || '',
    preco: product?.preco || 0,
    dosagem: product?.dosagem || '',
    categoria: product?.categoria || '',
    imagem_url: product?.imagem_url || '',
    limite_vendas_cupom: product?.limite_vendas_cupom ?? '',
    comissao_clinica_tipo: product?.comissao_clinica_tipo || 'percentual',
    comissao_clinica_valor: product?.comissao_clinica_valor || 0,
    comissao_representante_tipo: product?.comissao_representante_tipo || 'percentual',
    comissao_representante_valor: product?.comissao_representante_valor || 0,
    ativo: product ? product.ativo : true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ 
      ...formData, 
      preco: Number(formData.preco),
      limite_vendas_cupom: formData.limite_vendas_cupom === '' ? null : Number(formData.limite_vendas_cupom),

    });
  };

  const inputClass = "w-full p-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500";
  const labelClass = "block text-sm font-medium text-gray-700 mb-1";

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
    >
      <motion.div
        initial={{ scale: 0.9, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.9, y: 20 }}
        className="bg-white rounded-xl shadow-xl w-full max-w-lg"
      >
        <form onSubmit={handleSubmit}>
          <div className="p-6 border-b">
            <h3 className="text-lg font-semibold">{product ? 'Editar Produto' : 'Novo Produto'}</h3>
          </div>
          <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
            <div>
              <label htmlFor="nome" className={labelClass}>Nome do Produto</label>
              <input type="text" name="nome" value={formData.nome} onChange={handleChange} className={inputClass} required />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="preco" className={labelClass}>Preço (R$)</label>
                <input type="number" name="preco" step="0.01" value={formData.preco} onChange={handleChange} className={inputClass} required />
              </div>
              <div>
                <label htmlFor="dosagem" className={labelClass}>Dosagem</label>
                <input type="text" name="dosagem" value={formData.dosagem} onChange={handleChange} className={inputClass} placeholder="Ex: 3000mg, 30ml" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="categoria" className={labelClass}>Categoria</label>
                <input type="text" name="categoria" value={formData.categoria} onChange={handleChange} className={inputClass} placeholder="Ex: Óleo CBD Full Spectrum" />
              </div>
              <div>
                <label htmlFor="limite_vendas_cupom" className={labelClass}>Limite de Vendas com Cupom</label>
                <input type="number" name="limite_vendas_cupom" value={formData.limite_vendas_cupom} onChange={handleChange} className={inputClass} placeholder="Deixe em branco para ilimitado" />
              </div>
            </div>
            <div>
              <label htmlFor="descricao" className={labelClass}>Descrição</label>
              <textarea name="descricao" value={formData.descricao} onChange={handleChange} rows="3" className={inputClass}></textarea>
            </div>
            <div>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="ativo" checked={formData.ativo} onChange={handleChange} className="h-4 w-4 rounded text-emerald-600 focus:ring-emerald-500" />
                <span className={labelClass}>Produto Ativo</span>
              </label>
            </div>
            <div className="pt-4 border-t border-gray-200">
              <h4 className="font-medium text-gray-800 mb-2">Estrutura de Comissões</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className={labelClass}>Comissão da Clínica</label>
                  <div className="flex">
                    <select name="comissao_clinica_tipo" value={formData.comissao_clinica_tipo} onChange={handleChange} className={`${inputClass} rounded-r-none`}>
                      <option value="percentual">%</option>
                      <option value="valor_fixo">R$</option>
                    </select>
                    <input type="number" name="comissao_clinica_valor" value={formData.comissao_clinica_valor} onChange={handleChange} className={`${inputClass} rounded-l-none`} step="0.01" />
                  </div>
                </div>
                <div>
                  <label className={labelClass}>Comissão do Representante</label>
                  <div className="flex">
                    <select name="comissao_representante_tipo" value={formData.comissao_representante_tipo} onChange={handleChange} className={`${inputClass} rounded-r-none`}>
                      <option value="percentual">%</option>
                      <option value="valor_fixo">R$</option>
                    </select>
                    <input type="number" name="comissao_representante_valor" value={formData.comissao_representante_valor} onChange={handleChange} className={`${inputClass} rounded-l-none`} step="0.01" />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label htmlFor="imagem_url" className={labelClass}>URL da Imagem do Produto</label>
              <input type="text" name="imagem_url" value={formData.imagem_url} onChange={handleChange} className={inputClass} placeholder="https://exemplo.com/imagem.png" />
              {formData.imagem_url && (
                <img src={formData.imagem_url} alt="Preview" className="mt-2 h-20 w-20 object-cover rounded-lg border" />
              )}
            </div>
          </div>
          <div className="p-4 bg-gray-50 flex justify-end gap-3 rounded-b-xl">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300">Cancelar</button>
            <button type="submit" className="px-4 py-2 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700">Salvar Produto</button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
};

const UserManager = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [filterType, setFilterType] = useState('all');
  const [sortOrder, setSortOrder] = useState('date_desc'); // 'date_desc' ou 'name_asc'

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const response = await api.getAdminUsers();
        if (response.success) {
          setUsers(response.users);
        } else {
          throw new Error(response.error || "Falha ao carregar usuários.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleSave = async (userData) => {
    try {
      // A API de update de dados bancários só funciona para médico e representante.
      // Para outros, precisaríamos de uma rota de update genérica.
      // Por enquanto, a lógica de salvar está focada nos dados bancários.
      const userToUpdate = users.find(u => u.id === userData.id);
      let response;
      if (userToUpdate.tipo === 'medico' || userToUpdate.tipo === 'representante') {
        response = await api.updateUserBankingInfo(userData.id, userData);
      } else {
        // Aqui iria a chamada para uma API genérica de update de usuário
        // Ex: response = await api.updateUser(userData.id, userData);
        // Como não temos, vamos simular sucesso e atualizar localmente.
        console.log("Simulando atualização para usuário:", userData);
        response = { success: true };
      }

      if (response.success) {
        setUsers(prev => prev.map(u => u.id === userData.id ? {...u, ...userData} : u));
        setEditingUser(null);
        alert("Dados bancários atualizados com sucesso!");
      } else {
        throw new Error(response.error || "Falha ao atualizar dados.");
      }
    } catch (err) {
      alert(`Erro: ${err.message}`);
    }
  };

  const filteredAndSortedUsers = useMemo(() => {
    return users
      .filter(user => filterType === 'all' || user.tipo === filterType)
      .sort((a, b) => {
        if (sortOrder === 'name_asc') {
          return a.nome.localeCompare(b.nome);
        }
        // 'date_desc' é o padrão
        return new Date(b.criado_em) - new Date(a.criado_em);
      });
  }, [users, filterType, sortOrder]);

  const toggleSortOrder = () => {
    setSortOrder(prev => prev === 'name_asc' ? 'date_desc' : 'name_asc');
  };

  const typeLabels = {
    admin: 'Admin',
    medico: 'Clínica',
    representante: 'Representante',
    paciente: 'Paciente'
  };

  if (loading) return <div className="text-center p-6">Carregando usuários...</div>;
  if (error) return <div className="text-red-500 text-center p-6">Erro: {error}</div>;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
    >
      <div className="flex flex-wrap justify-between items-center mb-6 gap-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          <Users className="w-5 h-5 mr-2" />
          Gerenciamento de Usuários
        </h3>
        <div className="flex items-center gap-4">
          <div>
            <label htmlFor="filterType" className="sr-only">Filtrar por tipo</label>
            <select id="filterType" value={filterType} onChange={(e) => setFilterType(e.target.value)} className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500 focus:border-transparent">
              <option value="all">Todos os Tipos</option>
              <option value="admin">Admin</option>
              <option value="medico">Clínicas</option>
              <option value="representante">Representante</option>
              <option value="paciente">Paciente</option>
            </select>
          </div>
          <button onClick={toggleSortOrder} className="text-sm text-gray-600 hover:text-emerald-600 flex items-center gap-1">
            {sortOrder === 'name_asc' ? 'Ordenado por Nome (A-Z)' : 'Ordenado por Data (Recentes)'}
            <ChevronDown className={`w-4 h-4 transition-transform ${sortOrder === 'name_asc' ? 'rotate-180' : ''}`} />
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {filteredAndSortedUsers.length === 0 && (
          <p className="text-center text-gray-500 py-8">Nenhum usuário encontrado com os filtros selecionados.</p>
        )}
        {filteredAndSortedUsers.map(user => (
          <div key={user.id} className="border border-gray-200 rounded-lg p-4">
            <div className="flex justify-between items-center">
              <div>
                <p className="font-bold text-gray-800">{user.nome}</p>
                <p className="text-sm text-gray-600">{user.email}</p>
                <p className={`text-xs font-medium px-2 py-0.5 rounded-full inline-block mt-1 ${
                  {
                    admin: 'bg-red-100 text-red-800',
                    medico: 'bg-purple-100 text-purple-800',
                    representante: 'bg-blue-100 text-blue-800',
                    paciente: 'bg-green-100 text-green-800'
                  }[user.tipo]
                }`}>
                  {typeLabels[user.tipo] || user.tipo}
                </p>
              </div>
              <button
                onClick={() => setEditingUser(editingUser?.id === user.id ? null : user)}
                className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
              >
                <Edit3 className="w-4 h-4" />
                {editingUser?.id === user.id ? 'Fechar' : (user.tipo === 'medico' || user.tipo === 'representante' ? 'Editar Dados Bancários' : 'Editar Dados')}
              </button>
            </div>
            <AnimatePresence>
              {editingUser?.id === user.id && (
                <EditUserForm user={user} onSave={handleSave} onCancel={() => setEditingUser(null)} />
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

const SimpleEditForm = ({ user, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    nome: user.nome || '',
    email: user.email || '',
    telefone: user.telefone || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ id: user.id, ...formData });
  };

  // Reutiliza as classes para consistência visual
  const inputClass = "w-full p-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500";
  const labelClass = "block text-sm font-medium text-gray-700 mb-1";

  return (
    <motion.form
      initial={{ opacity: 0, height: 0, marginTop: 0 }}
      animate={{ opacity: 1, height: 'auto', marginTop: '16px' }}
      exit={{ opacity: 0, height: 0, marginTop: 0 }}
      onSubmit={handleSubmit}
      className="overflow-hidden"
    >
      <div className="border-t border-gray-200 pt-4">
        <h4 className="font-semibold text-gray-800 mb-4">Editar Dados Cadastrais</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="nome" className={labelClass}>Nome</label>
            <input type="text" name="nome" value={formData.nome} onChange={handleChange} className={inputClass} />
          </div>
          <div>
            <label htmlFor="email" className={labelClass}>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} className={inputClass} />
          </div>
          <div>
            <label htmlFor="telefone" className={labelClass}>Telefone</label>
            <input type="tel" name="telefone" value={formData.telefone} onChange={handleChange} className={inputClass} />
          </div>
        </div>
        <div className="flex justify-end space-x-3 mt-6">
          <button type="button" onClick={onCancel} className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2 rounded-lg text-sm font-medium">
            Cancelar
          </button>
          <button type="submit" className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2 rounded-lg text-sm font-medium flex items-center gap-2">
            <Save className="w-4 h-4" />
            Salvar Alterações
          </button>
        </div>
      </div>
    </motion.form>
  );
};

const EditUserForm = ({ user, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    banco: user.banco || '',
    agencia: user.agencia || '',
    conta: user.conta || '',
    tipo_conta: user.tipo_conta || 'corrente',
    pix_tipo: user.pix_tipo || 'cpf',
    pix_chave: user.pix_chave || '',
  });

  // Se o usuário não for médico ou representante, renderiza o formulário simples
  if (user.tipo !== 'medico' && user.tipo !== 'representante') {
    return <SimpleEditForm user={user} onSave={onSave} onCancel={onCancel} />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ id: user.id, ...formData });
  };

  const inputClass = "w-full p-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500";
  const labelClass = "block text-sm font-medium text-gray-700 mb-1";

  return (
    <motion.form
      initial={{ opacity: 0, height: 0, marginTop: 0 }}
      animate={{ opacity: 1, height: 'auto', marginTop: '16px' }}
      exit={{ opacity: 0, height: 0, marginTop: 0 }}
      onSubmit={handleSubmit}
      className="overflow-hidden"
    >
      <div className="border-t border-gray-200 pt-4">
        <h4 className="font-semibold text-gray-800 mb-4">Dados Bancários</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Coluna 1: Conta Corrente */}
          <div className="space-y-4 p-4 border rounded-lg bg-gray-50">
             <h5 className="font-medium">Conta Bancária</h5>
             <div>
                <label htmlFor="banco" className={labelClass}>Banco</label>
                <input type="text" name="banco" value={formData.banco} onChange={handleChange} className={inputClass} placeholder="Ex: 001 - Banco do Brasil"/>
             </div>
             <div>
                <label htmlFor="agencia" className={labelClass}>Agência (sem dígito)</label>
                <input type="text" name="agencia" value={formData.agencia} onChange={handleChange} className={inputClass} placeholder="Ex: 1234"/>
             </div>
             <div>
                <label htmlFor="conta" className={labelClass}>Conta (com dígito)</label>
                <input type="text" name="conta" value={formData.conta} onChange={handleChange} className={inputClass} placeholder="Ex: 12345-6"/>
             </div>
             <div>
                <label htmlFor="tipo_conta" className={labelClass}>Tipo de Conta</label>
                <select name="tipo_conta" value={formData.tipo_conta} onChange={handleChange} className={inputClass}>
                    <option value="corrente">Corrente</option>
                    <option value="poupanca">Poupança</option>
                </select>
             </div>
          </div>

          {/* Coluna 2: PIX */}
          <div className="space-y-4 p-4 border rounded-lg bg-gray-50">
            <h5 className="font-medium">PIX</h5>
            <div>
                <label htmlFor="pix_tipo" className={labelClass}>Tipo de Chave PIX</label>
                <select name="pix_tipo" value={formData.pix_tipo} onChange={handleChange} className={inputClass}>
                    <option value="cpf">CPF/CNPJ</option>
                    <option value="email">E-mail</option>
                    <option value="telefone">Telefone</option>
                    <option value="aleatoria">Chave Aleatória</option>
                </select>
            </div>
            <div>
                <label htmlFor="pix_chave" className={labelClass}>Chave PIX</label>
                <input type="text" name="pix_chave" value={formData.pix_chave} onChange={handleChange} className={inputClass} placeholder="Insira a chave PIX"/>
            </div>
          </div>

          {/* Coluna 3: Informações Adicionais (se houver) */}
          <div className="p-4">
            <p className="text-sm text-gray-600">
              Preencha os dados bancários para facilitar o processo de pagamento de comissões.
              <br/><br/>
              As informações de PIX e Conta Bancária são independentes. Você pode preencher uma, outra, ou ambas.
            </p>
          </div>
        </div>

        {/* Botões */}
        <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2 rounded-lg text-sm font-medium"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
            >
              <Save className="w-4 h-4" />
              Salvar Alterações
            </button>
        </div>
      </div>
    </motion.form>
  );
};

export default DashboardAdmin;
